/**
 * Formats a page info object into a pagination object.
 * @param {Object} pageInfo - The page info object.
 * @returns {Object|false} The formatted pagination object or false if the page info is invalid.
 */
export function formatPagination(pageInfo) {
    if(pageInfo && typeof pageInfo.count === 'number') {
        return {
            current: pageInfo.page || 1,
            pageSize: pageInfo.perPage,
            total: pageInfo.count,
            showSizeChanger: true,
            pageSizeOptions: ['10', '20', '50'],
            showTotal: (total) => `Total ${total} items`
        }
    }
    return false;
}

/**
 * Normalises a paginated API response into the shape the
 * `@clockout-dev/design-elements` Table expects: `{ rows, pageInfo }`.
 */
export function normalizePageResult(result, page, perPage) {
    const rows = Array.isArray(result?.rows) ? result.rows : [];
    const responsePageInfo = result?.pageInfo && typeof result.pageInfo === 'object'
        ? result.pageInfo
        : null;

    const pageInfo = responsePageInfo
        ? {
            current: responsePageInfo.current ?? page,
            perPage: responsePageInfo.perPage ?? perPage,
            total: typeof responsePageInfo.total === 'number'
                ? responsePageInfo.total
                : rows.length,
        }
        : {
            current: page,
            perPage,
            total: typeof result?.total === 'number' ? result.total : rows.length,
        };

    return { rows, pageInfo };
}